import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';


export function addSvgIcons(iconRegistry: MatIconRegistry, domSanitizer: DomSanitizer, iconNames: string[]): void {
  for (const iconName of iconNames) {
    iconRegistry.addSvgIcon(iconName, domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${iconName}.svg`));
  }
}
